import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=9c6bfd6a&scoped=true"
import script from "./FilesList.vue?vue&type=script&lang=ts"
export * from "./FilesList.vue?vue&type=script&lang=ts"
import style0 from "./FilesList.vue?vue&type=style&index=0&id=9c6bfd6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6bfd6a",
  null
  
)

export default component.exports